export const fiscalYearEndpoints = {
  LIST: (orgId: string) => `/api/organizations/${orgId}/fiscal-years/`,
  CREATE: (orgId: string) => `/api/organizations/${orgId}/fiscal-years/`,
  DETAIL: (orgId: string, fyId: string) =>
    `/api/organizations/${orgId}/fiscal-years/${fyId}/`,
  UPDATE: (orgId: string, fyId: string) =>
    `/api/organizations/${orgId}/fiscal-years/${fyId}/`,
  DELETE: (orgId: string, fyId: string) =>
    `/api/organizations/${orgId}/fiscal-years/${fyId}/`,
  SET_ACTIVE: (orgId: string, fyId: string) =>
    `/api/organizations/${orgId}/fiscal-years/${fyId}/set-active/`,
};
